import { render, staticRenderFns } from "./UserProfileIcon.vue?vue&type=template&id=06dfa23f"
import script from "./UserProfileIcon.vue?vue&type=script&lang=js"
export * from "./UserProfileIcon.vue?vue&type=script&lang=js"
import style0 from "./UserProfileIcon.vue?vue&type=style&index=0&id=06dfa23f&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06dfa23f')) {
      api.createRecord('06dfa23f', component.options)
    } else {
      api.reload('06dfa23f', component.options)
    }
    module.hot.accept("./UserProfileIcon.vue?vue&type=template&id=06dfa23f", function () {
      api.rerender('06dfa23f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserProfileIcon/UserProfileIcon.vue"
export default component.exports